import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import Col from '../col'
import Card from '../card'
import ListingInfo from '../listingInfo'
import ListingSale from '../listingSale'
import ListingMedia from '../listingMedia/listingMedia'
import PreferenceContext from '../../contexts/userPreferenceContext'
import ElementErrorBoundary from '../elementErrorBoundary/elementErrorBoundary'

const ListingListItem = ({
  hasStarted,
  listingUuid,
  query,
  currentLanguageCode
}) => {
  const lotNumber = useSelector((state) => state.lots.listings[listingUuid]?.lotNumber)
  const { isListLayout } = useContext(PreferenceContext)
  if (!lotNumber) return null

  return (
    <Col xs={12} sm={6} md={4} className={isListLayout ? 'timed-listing--list-layout' : 'timed-listing--grid-layout'}>
      <Card
        className='lot timed-listing'
        id={`timed-listing__${lotNumber}`}
      >
        <ListingMedia
          key={`listingMedia${listingUuid}`}
          currentLanguageCode={currentLanguageCode}
          listingUuid={listingUuid}
          query={query}
        />
        <div className='lot__textual'>
          <ElementErrorBoundary>
            <ListingInfo
              key={`listingInfo${listingUuid}`}
              currentLanguageCode={currentLanguageCode}
              listingUuid={listingUuid}
              query={query}
            />
            <ListingSale
              hasStarted={hasStarted}
              key={`listingSale${listingUuid}`}
              currentLanguageCode={currentLanguageCode}
              listingUuid={listingUuid}
            />
          </ElementErrorBoundary>
        </div>
      </Card>
    </Col>
  )
}

ListingListItem.propTypes = {
  currentLanguageCode: PropTypes.string,
  hasStarted: PropTypes.bool.isRequired,
  listingUuid: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired
}

const isEqual = (a, b) => a.listingUuid === b.listingUuid &&
  a.query === b.query &&
  a.hasStarted === b.hasStarted &&
  a.currentLanguageCode === b.currentLanguageCode &&
  a.children === b.children

export default React.memo(ListingListItem, isEqual)
